import { useState } from 'react';
import { useTheme, styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from "../MainCard";
import moment from 'moment/moment';
import PresetDateRangePicker from '../PresetDateRangePicker';
import { DateRangePicker } from 'react-dates';

// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
}));
// ==============================|| DASHBOARD - TOTAL INCOME LIGHT CARD ||============================== //

const today = moment();
const yesterday = moment().subtract(1, 'day');
const presets = [{
    text: 'Today',
    start: today,
    end: today,
},
{
    text: 'Yesterday',
    start: yesterday,
    end: yesterday,
}]
const isOutsideRange = (day) => {
    return day.isAfter(today.clone().endOf('day')); // Disables dates after today
};
const TopBar = ({ isLoading, startDate, endDate, setStartDate, setEndDate }) => {
    const theme = useTheme();
    const [focusedInput, setFocusedInput] = useState(null);
    return (
        <>
            {/* {isLoading ? (
                <TotalIncomeCard />
            ) : ( */}
            <CardWrapper className="admin-topbar" border={false} content={false}>
                <Box sx={{ p: 1, backgroundColor: '#f7f7f7' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} alignItems="left">
                            <Typography color='#000' align='left' sx={{ fontWeight: '700', fontSize: '2rem', fontWeight: 700, mt: 1.75 }}>
                                Muranga Subsidy Services
                            </Typography>
                        </Grid>
                        <Grid item xs={6} align="right">
                            {/* <DateRangePicker
                                startDate={startDate}
                                startDateId="s_id"
                                endDate={endDate}
                                endDateId="e_id"
                                onDatesChange={({ startDate, endDate }) => {
                                    setStartDate(startDate);
                                    setEndDate(endDate);
                                }}
                                focusedInput={focusedInput}
                                onFocusChange={(e) => setFocusedInput(e)}
                                displayFormat="DD/MM/YYYY"
                                isOutsideRange={isOutsideRange}
                            /> */}

                            <PresetDateRangePicker
                                presets={presets}
                                autoFocus
                                startDate={startDate}
                                startDateId="s_id"
                                endDate={endDate}
                                endDateId="e_id"
                                onDatesChange={({ startDate, endDate }) => {
                                    setStartDate(startDate);
                                    setEndDate(endDate);
                                }}
                                focusedInput={focusedInput}
                                onFocusChange={(e) => setFocusedInput(e)}
                                displayFormat="DD/MM/YYYY"
                                isOutsideRange={isOutsideRange}
                                setStartDate={setStartDate}
                                setEndDate = {setEndDate}

                            />


                        </Grid>

                    </Grid>
                </Box>
            </CardWrapper>
            {/* )} */}
        </>
    );
};

TopBar.propTypes = {
    isLoading: PropTypes.bool
};

export default TopBar;